import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/common/main.scss'
import router from './router';

Vue.use(ElementUI);

Vue.config.productionTip = false;

// 设置页面标题
document.title = '投稿';

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');

